import React from "react";

export default function AboutUs() {
  return (
    <div className="aboutus-wrapper">
      {/* HERO / HEADER */}
      <section className="container text-center py-5 mt-5">
        <h6 className="text-roberto text-uppercase fw-bold mb-2">Get To Know Us</h6>
        <h1 className="display-4 fw-bold mb-3">About Us - Nivara Agro Tourism</h1>
        <p className="text-muted mx-auto" style={{ maxWidth: "700px" }}>
          A journey back to nature, built on hospitality, sustainability, and unforgettable memories.
        </p>
      </section>

      {/* OUR JOURNEY */}
      <section className="container py-5">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <h6 className="text-roberto text-uppercase fw-bold mb-3">🌿 Our Journey</h6>
            <h2 className="fw-bold mb-4">From A Simple Dream To A Riverside Retreat</h2>
            <p className="text-muted leading-relaxed mb-3">
              Nivara Agro Tourism was born from a simple yet powerful dream — to create a space
              where the chaos of city life fades away and the soothing rhythm of nature takes
              over. Nestled along the scenic riverbanks, Nivara Agro Tourism began its journey as
              a humble retreat for those seeking solace in the arms of nature. What started as a
              small passion project has blossomed into one of the most sought-after agro tourism
              destinations in the region.
            </p>
            <p className="text-muted leading-relaxed mb-3">
              Over the years, we have welcomed thousands of guests — families, solo travelers,
              couples, and corporate groups — all of whom came looking for something real,
              something raw, and something refreshing. With every passing season, we have grown
              not just in size but in our commitment to delivering experiences that stay etched in
              the hearts of our visitors long after they leave.
            </p>
            <p className="text-muted leading-relaxed">
              Our story is not just about a place — it is about the moments created here, the
              laughter shared around a bonfire, the thrill of paddling through the river, and the
              peace found in watching a golden sunrise from a riverside tent. That is the story of
              Nivara Agro Tourism, and it is still being written — one unforgettable stay at a
              time.
            </p>
          </div>
          <div className="col-lg-6">
            <div className="row g-3">
              <div className="col-8">
                <img
                  //src="https://images.unsplash.com/photo-1500530855697-b586d89ba3ee"
                  src="/images/tapolaview.jpg"
                  className="img-fluid rounded shadow"
                  alt="riverside retreat"
                />
              </div>
              <div className="col-4">
                <img
                 // src="https://images.unsplash.com/photo-1502920917128-1aa500764cbd"
                 src="/images/kayakingmen.jpg"
                  className="img-fluid rounded shadow mb-3"
                  alt="nature stay"
                />
                <img
                  //src="https://images.unsplash.com/photo-1445308394109-4ec2920981b1"
                  src="/images/frontviewside.jpg"
                  className="img-fluid rounded shadow"
                  alt="bonfire evening"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PURPOSE AND GOALS */}
      <section className="bg-light py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h6 className="text-roberto text-uppercase fw-bold mb-2">🎯 Our Purpose and Goals</h6>
            <h2 className="fw-bold text-success display-6">Why We Do What We Do</h2>
            <p className="text-muted mx-auto mt-3" style={{ maxWidth: "750px" }}>
              At Nivara Agro Tourism, our purpose is deeply rooted in bringing people closer to
              nature while offering world-class comfort and hospitality. We believe that every
              individual deserves a break — a moment to breathe, explore, and reconnect with the
              natural world around them.
            </p>
          </div>

          <div className="row g-4">
            {[
              "To provide a safe, inclusive, and nature-immersive experience for every guest who walks through our doors.",
              "To promote sustainable and responsible tourism that respects the environment and supports the local community.",
              "To offer affordable yet premium experiences that make agro tourism accessible to everyone, regardless of their budget.",
              "To continuously innovate and expand our activities and services to keep our guests engaged, excited, and always coming back for more.",
              "To build a community of nature lovers who share our passion for the outdoors and carry that love with them wherever they go.",
            ].map((goal, idx) => (
              <div className="col-md-6 col-lg-4" key={idx}>
                <div className="card h-100 border-0 shadow-sm p-4">
                  <p className="mb-0 text-muted">{goal}</p>
                </div>
              </div>
            ))}
          </div>

          <p className="text-center text-muted mt-5 mb-0 fst-italic">
            We are not just a tourism destination — we are a movement toward mindful travel, and
            we are proud to lead the way.
          </p>
        </div>
      </section>

      {/* TEAM */}
      <section className="container py-5">
        <div className="text-center mb-5">
          <h6 className="text-roberto text-uppercase fw-bold mb-2">
            👨‍👩‍👧‍👦 Meet Our Wonderful Team
          </h6>
          <h2 className="fw-bold text-success display-6">The People Behind Your Experience</h2>
          <p className="text-muted mx-auto mt-3" style={{ maxWidth: "750px" }}>
            Behind every great experience at Nivara Agro Tourism is a dedicated team of passionate
            individuals who pour their heart and soul into making your stay extraordinary.
          </p>
        </div>

        <div className="row g-4">
          {[
            {
              title: "Our Hospitality Crew",
              desc: "Warm, welcoming, and always ready with a smile, our front-desk and accommodation team ensures that from the moment you check in to the moment you check out, your comfort is their top priority.",
            },
            {
              title: "Our Adventure Guides",
              desc: "Trained, certified, and deeply experienced, our adventure guides are the backbone of every kayaking session, boating trip, and outdoor activity. Safety is their first language, and fun is their second.",
            },
            {
              title: "Our Kitchen Team",
              desc: "A talented group of culinary enthusiasts who craft delicious vegetarian and non-vegetarian meals using fresh, locally sourced ingredients. Every plate served is prepared with love, tradition, and a pinch of magic.",
            },
            {
              title: "Our Grounds and Maintenance Team",
              desc: "Working behind the scenes, this hardworking team ensures that every corner of Nivara Agro Tourism is clean, safe, and picture-perfect for your arrival.",
            },
          ].map((member, idx) => (
            <div className="col-md-6 col-lg-3" key={idx}>
              <div className="card h-100 border-0 shadow-sm text-center p-4">
                <h5 className="fw-bold text-roberto mb-3">{member.title}</h5>
                <p className="text-muted small mb-0">{member.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-muted mt-5 mb-0 fst-italic">
          Together, our team works as one cohesive unit, united by the shared goal of making your
          visit to Nivara Agro Tourism the highlight of your year.
        </p>
      </section>
    </div>
  );
}